import { BuildingType } from '../buildings';
import imgOutside from '../../assetsFr/buildings/industry/outside.jpg';
import imgWater from '../../assetsFr/buildings/industry/water.jpg';
import imgProduction from '../../assetsFr/buildings/industry/production.jpg';
import imgLab from '../../assetsFr/buildings/industry/lab.jpg';
import imgFireProtection from '../../assetsFr/buildings/industry/fire-protection.jpg';
import imgSprinklerCenter from '../../assetsFr/buildings/industry/sprinkler-center.jpg';
import imgHeating from '../../assetsFr/buildings/industry/heating.jpg';
import { BuildingArea, SubBuilding } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';

const industryConfig: BuildingArea = {
    techSectors: [
        {
            type: TechSector.WATER,
            img: imgOutside,
            buildings: [
                {
                    coordinates: { x: 230, y: 577 },
                    building: BuildingType.INDUSTRY_PRODUCTION,
                    link: `${BuildingType.INDUSTRY_PRODUCTION}/${TechSector.WATER}`,
                    showSector: false,
                },
                {
                    coordinates: { x: 700, y: 424 },
                    building: BuildingType.INDUSTRY_WATER,
                    link: `${BuildingType.INDUSTRY_WATER}/${TechSector.WATER}`,
                    showSector: false,
                },
                {
                    coordinates: { x: 1007, y: 526 },
                    building: BuildingType.INDUSTRY_LAB,
                    link: `${BuildingType.INDUSTRY_LAB}/${TechSector.WATER}`,
                    showSector: false,
                },
            ],
        },
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            buildings: [
                {
                    coordinates: { x: 1462, y: 343 },
                    building: BuildingType.INDUSTRY_SPRINKLER_CENTER,
                    link: `${BuildingType.INDUSTRY_SPRINKLER_CENTER}/${TechSector.FIRE_PROTECTION}`,
                    showSector: false,
                },
            ],
        },
    ],
    img: imgOutside,
};

export const industryLabConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgLab,
    techSectors: [
        {
            type: TechSector.WATER,
        },
    ],
    products: [
        {
            position: { x: 338, y: 608 },
            type: ProductType.KSB_SAFETY_BOOST,
        },
    ],
};

export const industryWaterConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgWater,
    techSectors: [
        {
            type: TechSector.WATER,
        },
    ],
    products: [
        {
            position: { x: 878, y: 590 },
            type: ProductType.DELTA_PRIMO_SVP,
        },
    ],
};

export const industryProductionConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgProduction,
    techSectors: [
        {
            type: TechSector.WATER,
        },
    ],
    products: [
        {
            position: { x: 1515, y: 558 },
            type: ProductType.ETANORM,
        },
        {
            position: { x: 1682, y: 521 },
            type: ProductType.BOA_COMPACT_EKB,
        },
    ],
};

export const industryTestcenterConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgProduction,
    techSectors: [],
    products: [],
};

export const industryHeatingCenterConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgHeating,
    techSectors: [
        {
            type: TechSector.HEATING,
        },
    ],
    products: [
        {
            position: { x: 700, y: 510 },
            type: ProductType.BOA_H,
        },
        {
            position: { x: 745, y: 340 },
            type: ProductType.SERIE_2000,
        },
        {
            position: { x: 1240, y: 420 },
            type: ProductType.BOA_SYSTRONIC_EPIC,
        },
        {
            position: { x: 1385, y: 200 },
            type: ProductType.ETALINE_SYT,
        },
    ],
};

export const industrySprinklerCenterConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgSprinklerCenter,
    techSectors: [
        {
            type: TechSector.FIRE_PROTECTION,
        },
    ],
    products: [
        {
            position: { x: 125, y: 605 },
            type: ProductType.KSB_SAFETY_BOOST,
        },
        {
            position: { x: 1191, y: 212 },
            type: ProductType.ETANORM_FXV,
        },
        {
            position: { x: 1432, y: 349 },
            type: ProductType.HYASOLO_2_D_FL_COMPACT,
        },
    ],
};

export default industryConfig;
